import * as React from "react"

const Exclamation = () => (
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width={2.026}
  //   height={14.18}
  // >
  //   <path
  //     d="M9.726 13.291H7.7V3.163h2.026zm0 2.026H7.7v2.026h2.026z"
  //     transform="translate(-7.7 -3.163)"
  //   />
  // </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={682.667}
    height={682.667}
    viewBox="0 0 512 512"
  >
    <path d="M248.4 64.9c-5.9 1.5-13.8 6.6-17.6 11.4-7.7 9.8-7.5 1.9-2.8 127.5 2.5 69.6 4.5 113.2 5.3 115.7 2.4 8.5 13.5 16.5 22.7 16.5 9.5 0 20.4-8.1 22.8-17 1.9-7.3 9.7-224.1 8.2-230.7-2-9.3-9.5-17.9-19-22-4.2-1.7-15.2-2.5-19.6-1.4zM246 385.6c-22.7 8.2-29.3 36.2-12.5 52.9 6.6 6.6 12.5 9 22.5 8.9 10 0 16-2.4 22.5-8.9s8.9-12.5 8.9-22.5c.1-10-2.3-15.9-8.9-22.5-8.2-8.2-22.2-11.6-32.5-7.9z" />
  </svg>
)

export default Exclamation;